import React from "react";
import { OperationCompletedPanel } from "../layout/OperationCompletedPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

export const MaintenanceMode = () => {
  return (
    <OperationCompletedPanel
      message={formatMessage("cof.access.message.error.maintenancemode")}
      alt={formatMessage("cof.access.message.error.maintenancemode")}
      icon="/assets/undermaintenance.svg"
    />
  );
};
